import {FC, PropsWithChildren} from "react";
import Typography from "@mui/material/Typography";
import BaseDivider from "@mui/material/Divider";

type DividerProps = PropsWithChildren

export const Divider: FC<DividerProps> = ({children}) => {
    return (
        <BaseDivider component="div" role="presentation">
            <Typography fontSize={12}>{children}</Typography>
        </BaseDivider>
    )
}
